module.exports = __webpack_public_path__ + "static/img/warehouse3.d22ffb9.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/warehouse3.png
// module id = smnW
// module chunks = 1